import { Edit } from "./edit";

export const Bonuses = { Tabs: Edit.List };
